import { createClient } from "@prismicio/client"
import { useQuery } from "@tanstack/react-query"

import { useAPIExplorer } from "../components/APIExplorerContext"

export function useRequestRepositoryTags() {
  const { request, config } = useAPIExplorer()

  const { data: tags } = useQuery({
    queryKey: [
      "getTags",
      {
        id: request.repository.id,
        accessToken: request.repository.accessToken,
        documentAPIEndpoint: config.repository?.documentAPIEndpoint,
      },
    ],
    queryFn: () => {
      const client = createClient(request.repository.id, {
        documentAPIEndpoint: config.repository?.documentAPIEndpoint,
        accessToken: request.repository.accessToken,
      })

      return client.getTags()
    },
  })

  return tags
}
